<template>
  <v-dialog v-if="isOpen" scrollable max-width="1200">
    <!-- <v-dialog v-model="props.isOpen" scrollable max-width="1200" @click:outside="dialogFilterClose()"> -->
    <v-card>
      <!-- <div :style="{ display: 'flex', justifyContent: 'center', padding: '3rem 0' }" v-if="progresLineShow">
        <v-progress-circular indeterminate />
      </div> -->
      <template>
        <v-toolbar dense flat dark>
          <!-- <v-btn icon dark @click="dialogClientClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
          <!-- <v-toolbar-title>Детально про клієнта: {{ detailKlientPib }} </v-toolbar-title> -->
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn text v-show="detailKlientChe" @click="dialogClientSaveAndClose()">Зберегти зміни</v-btn> -->
            <!-- <v-btn dark text @click="dialogClientClose()">Закрити</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="min-height: 600px;">

          <v-form>
            <v-container>
              <!-- <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field outlined dense v-model="detailClientFormControl.pib" label="Призвіще І.П."
                    @change="detailKlientChe = true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-select item-text="name" item-value="id" :items="this.filterNaspList"
                    :value="this.detailClientFormControl.nasp" @input="(event) => handleSelectNasp(event)"
                    label="Населений пункт" outlined dense @change="detailKlientChe = true"></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select item-text="name" item-value="id" :items="this.filterStreetList" :value="3536"
                    @input="(event) => handleSelectStreet(event)" label="Вулиця" outlined dense
                    @change="detailKlientChe = true"></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field outlined dense v-model="detailClientFormControl.building" label="Будинок"
                    @change="detailKlientChe = true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field outlined dense v-model="detailClientFormControl.kv" label="Квартира"
                    @change="detailKlientChe = true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <v-text-field outlined dense v-model="detailClientFormControl.tel" label="Телефон1"
                    @change="detailKlientChe = true"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field dense outlined v-model="detailClientFormControl.model" label="Модель котла"
                    @change="detailKlientChe = true"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-menu v-model="DatpPicker" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="detailClientFormControl.datp" label="Дата пуску" prepend-icon="event"
                        readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="detailClientFormControl.datp" locale="uk" :first-day-of-week="1"
                      @input="chDatp()"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-textarea dense outlined v-model="detailClientFormControl.coment" label="Коментар"
                    @change="detailKlientChe = true"></v-textarea>
                </v-col>

              </v-row> -->
            </v-container>
          </v-form>
          <!-- <v-data-table dense :headers="detailKlientTableHeaders" :items="detailKlientTableItems"></v-data-table> -->
        </v-card-text>
      </template>
    </v-card>
  </v-dialog>
</template>

  <script>
export default {
  props: ['isOpen'],
}
</script>
